// helper method to create query string from object
export default {
    serializeObjToQueryString(obj) {
        const str = [];
        for (const p in obj) {
            if (obj.hasOwnProperty(p)) {
                str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
            }
        }
        return str.join('&');
    },
    // helper method to convert query string to object
    deserializeQueryStringToObject() {
        const pairs = window.location.search.substring(1).split('&');
        const obj = {};
        let pair;
        let i;

        for (i in pairs) {
            if (pairs[i] === '') {
                continue;
            }
            pair = pairs[i].split('=');
            // pair.shift() -first element, pair.join('=')- all other elements merged
            obj[decodeURIComponent(pair.shift())] = decodeURIComponent(pair.join('='));
        }

        return obj;
    }
}

